<form (submit)="createPatient()"
      [formGroup]="form"
      name="create-patient-form">
  <div class="modal-body">
    <div class="modal-header-wrapper">
      <h2 class="title-text">Créer un nouveau patient</h2>
      <p class="subtitle-text">Créez le compte de votre patient et invitez-le par email à télécharger l'application
        MonSuiviDiet.</p>
    </div>
    <div id="modal-content-wrapper">
      <div class="form-row-wrapper">
        <div id="last-name-form" class="form-field input-row required">
          <label>Nom</label>
          <input type="text" [class.is-invalid]="lastNameInvalid" class="form-control" id="last-name-input"
                 placeholder="Connor" formControlName="lastName">
          <div class="invalid-feedback">
            Veuillez entrer un nom valide.
          </div>
        </div>
        <div id="first-name-form" class="form-field input-row required">
          <label>Prénom</label>
          <input type="text" [class.is-invalid]="firstNameInvalid" class="form-control" placeholder="Sarah"
                 id="first-name-input" formControlName="firstName">
          <div class="invalid-feedback">
            Veuillez entrer un prénom valide.
          </div>
        </div>
      </div>
      <div class="form-row-wrapper">
        <div id="phone-form" class="form-field input-row required">
          <label>Téléphone</label>
          <div class="phone-wrapper" [class.is-invalid]="phoneInvalid">
            <select class="form-control form-select" [class.is-invalid]="phoneInvalid" id="phone-country-select"
                    formControlName="phoneCountry" aria-label="Sélectionner un pays">
              <option value="" selected disabled>Pays</option>
              <option *ngFor="let featuredCountry of featuredCountries" [title]="featuredCountry?.country_name"
                      [attr.aria-label]="featuredCountry?.country_name"
                      [value]="featuredCountry?.alpha2">{{featuredCountry?.country_name}}</option>
              <option disabled>──────────</option>
              <option *ngFor="let country of countries" [title]="country.country_name"
                      [attr.aria-label]="country.country_name"
                      [value]="country.alpha2">{{country.country_name}}</option>
            </select>
            <input type="tel" [class.is-invalid]="phoneInvalid" placeholder="6..." class="form-control" id="phone-input"
                   formControlName="phone">
          </div>
          <div class="invalid-feedback">
            Veuillez sélectionner un pays et entrer un numéro valide.
          </div>
        </div>
        <div id="email-form" class="form-field input-row">
          <label>Email</label>
          <input type="email" [class.is-invalid]="emailInvalid" placeholder="mail@example.com" class="form-control"
                 id="email-input" formControlName="email">
          <div class="invalid-feedback">
            Veuillez entrer une adresse email valide.
          </div>
        </div>
      </div>
      <div class="form-row-wrapper">
        <div id="gender-form" class="form-field input-row">
          <label>Genre</label>
          <select [class.is-invalid]="genderInvalid" class="form-control custom-select"
                  id="gender-input" formControlName="gender">
            <option value="" selected disabled>Choisir un genre...</option>
            <option value="WOMAN">Femme</option>
            <option value="MAN">Homme</option>
            <option value="NB">Non binaire</option>
          </select>
          <div class="invalid-feedback">
            Veuillez sélectionner un genre.
          </div>
        </div>
        <div id="birthday-form" class="form-field input-row">
          <label>Date de naissance</label>
          <input type="date" (change)="onBirthdayChange($event.target)" name="birthday"
                 [class.is-invalid]="birthdayInvalid" placeholder="mail@example.com" class="form-control"
                 id="birthday-input"
                 formControlName="birthday">
          <div class="invalid-feedback">
            Veuillez entrer une date valide.
          </div>
        </div>
      </div>

      <div id="address-form" class="form-field">
        <label>Adresse</label>
        <input type="text" placeholder="6 chemin des lilas" class="form-control" id="address-input"
               formControlName="address" [class.is-invalid]="addressInvalid">
        <div class="invalid-feedback">
          Veuillez entrer une adresse postale valide.
        </div>
      </div>

      <div class="form-row-wrapper">
        <div id="postal-code-form" class="form-field input-row">
          <label>Code postal</label>
          <input type="text" [class.is-invalid]="postalCodeInvalid" placeholder="75000" class="form-control"
                 id="postal-code-input" formControlName="postalCode">
          <div class="invalid-feedback">
            Veuillez entrer un code postal valide.
          </div>
        </div>
        <div id="city-form" class="form-field input-row">
          <label>Ville</label>
          <input type="text" [class.is-invalid]="cityInvalid" placeholder="Paris" class="form-control" id="city-input"
                 formControlName="city">
          <div class="invalid-feedback">
            Veuillez entrer un nom de ville valide.
          </div>
        </div>
        <div id="country-form" class="form-field input-row">
          <label>Pays</label>
          <select class="form-control form-select" [class.is-invalid]="countryInvalid" id="country-select"
                  formControlName="country" aria-label="Sélectionner un pays">
            <option value="" selected disabled>Sélectionner un pays</option>
            <option *ngFor="let featuredCountry of featuredCountries" [title]="featuredCountry?.country_name"
                    [attr.aria-label]="featuredCountry?.country_name" [value]="featuredCountry?.alpha2">
              {{ featuredCountry?.country_name }}
            </option>
            <option disabled>──────────</option>
            <option *ngFor="let country of countries" [value]="country.alpha2">{{ country.country_name }}</option>
          </select>
          <div class="invalid-feedback">
            Veuillez sélectionner un pays.
          </div>
        </div>
      </div>

      <div id="consultation-reason-form" class="form-field">
        <label>Motif de consultation</label>
        <input type="text" [class.is-invalid]="consultationReasonInvalid" placeholder="Entrer le motif de consultation"
               class="form-control" id="consultation-reason-input" formControlName="consultationReason">
        <div class="invalid-feedback">
          Veuillez entrer une raison.
        </div>
      </div>
      <div *ngIf="!enabledSendEmail()" id="send-email-disabled-form" class="form-check">
        <input [class.is-invalid]="sendEmailInvalid"
               [attr.disabled]="true"
               class="form-check-input"
               id="send-email-disabled-checkbox"
               type="checkbox">
        <label class="form-check-label call-to-action-md" for="send-email-disabled-checkbox">
          Envoyer un email au patient (Veuillez renseigner l'email)
        </label>
      </div>

      <div *ngIf="enabledSendEmail()" id="send-email-form" class="form-check">
        <input (change)="onSendEmailChange($event)"
               [class.is-invalid]="sendEmailInvalid"
               class="form-check-input"
               formControlName="sendEmail"
               id="send-email-checkbox"
               type="checkbox">
        <label class="form-check-label call-to-action-md" for="send-email-checkbox">
          Envoyer un email au patient
        </label>
      </div>

      <msd-invitation-editor (changeInvitationTemplate)="onChangeInvitationTemplate($event)"
                             (invalidInvitationTemplate)="invalidInvitationTemplate = $event"
                             [maxRows]="8"
                             [visible]="visibleInvitationTemplate && enabledSendEmail()"
                             [patientPhoneNumber]="patientPhoneNumber">
      </msd-invitation-editor>

      <div *ngIf="error" class="alert alert-danger mt-1" role="alert">
        {{ error }}
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal()" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="validate-button" type="submit" [disabled]="!form.valid || isLoading"
            class="btn btn-primary btn-gradient">
      <ng-container *ngIf="isLoading else validateButton">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span class="visually-hidden">Chargement...</span>
      </ng-container>
      <ng-template #validateButton>
        Valider
      </ng-template>
    </button>
  </div>
</form>
